import memoize from '../utils/memoize.utils'

export const allowedMultiPlateBookingsLots = ['003-058']

export const getMultiPlateBookingsLots = () => {
    const isStaging = window.location.hostname.includes('localhost') || window.location.hostname.includes('stage')
    return isStaging ? ['A539'] : allowedMultiPlateBookingsLots
}

export const getMultiPlateBookingsLotsMemoized = memoize(getMultiPlateBookingsLots)
